module.exports = __webpack_public_path__ + "static/media/pf-gear.5ad568ed.svg";